import { useTranslation } from 'react-i18next'
import {
  SERVICE_CONFIRMATION,
  serviceRowLabel,
  serviceConfirmStatusLabel,
} from '@/types/tariffs'

/**
 * Справочная диаграмма «Когда подтверждается услуга».
 * Не редактируется. Маппинг 4 услуг (выезд / осмотр / сделка / доставка)
 * на статусы воронки (§1.1 TARIFFS_SPEC.md).
 */
export function ServiceConfirmationDiagram() {
  const { t } = useTranslation()
  return (
    <div className="rounded-xl border border-[color:var(--stryzh-color-border-default)] bg-[color:var(--stryzh-color-surface)] p-4">
      <p className="mb-3 font-[family-name:var(--stryzh-font-family-inter)] text-[length:var(--stryzh-font-size-sm)] text-[color:var(--stryzh-color-text-secondary)]">
        {t('tariffs.confirm.intro')}{' '}
        <code>APPRAISAL</code> {t('tariffs.confirm.introAnd')}{' '}
        <code>PAYMENT_TRANSFER</code>.
      </p>
      <ol className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICE_CONFIRMATION.map((row, idx) => (
          <li
            key={row.code}
            className="flex flex-col gap-1 rounded-lg border border-[color:var(--stryzh-color-border-subtle)] bg-[color:var(--stryzh-color-void)] p-3"
          >
            <span className="font-[family-name:var(--stryzh-font-family-mono)] text-[length:var(--stryzh-font-size-xs)] text-[color:var(--stryzh-color-text-secondary)]">
              {t('tariffs.confirm.step', { n: idx + 1 })}
            </span>
            <span className="font-[family-name:var(--stryzh-font-family-space-grotesk)] text-[length:var(--stryzh-font-size-lg)] font-semibold text-[color:var(--stryzh-color-text-primary)]">
              {serviceRowLabel(row.code)}
            </span>
            <span className="font-[family-name:var(--stryzh-font-family-inter)] text-[length:var(--stryzh-font-size-sm)] text-[color:var(--stryzh-color-text-secondary)]">
              {t('tariffs.confirm.onStatus')}{' '}
              <span className="font-[family-name:var(--stryzh-font-family-mono)] text-[color:var(--stryzh-color-accent-orange)]">
                {row.status}
              </span>{' '}
              «{serviceConfirmStatusLabel(row.code)}»
            </span>
          </li>
        ))}
      </ol>
    </div>
  )
}
